import { useMemberSettings } from "@hooks/useMemberSettings";
import { isFirebaseAvailable } from "@utils/firebase";
import { useMemo } from "react";

export enum GoogleAuthMethod {
  Firebase = "firebase",
  GoogleOAuth = "google-oauth",
}

/**
 * Determines which Google authentication method to use based on:
 * - Backend settings (googleAuthEnabled)
 * - Environment configuration (Firebase config availability)
 *
 * Logic:
 * - If Google Auth is enabled from BE AND Firebase config exists -> use Firebase
 * - If Google Auth is enabled from BE AND Firebase config does NOT exist -> use Google OAuth (existing)
 * - If Google Auth is disabled from BE -> return null (no auth)
 */
export const useGoogleAuthMethod = (): GoogleAuthMethod | null => {
  const { googleAuthEnabled } = useMemberSettings();

  return useMemo(() => {
    if (!googleAuthEnabled) {
      return null;
    }

    const firebaseAvailable = isFirebaseAvailable();

    if (firebaseAvailable) {
      return GoogleAuthMethod.Firebase;
    }

    // Fallback to existing Google OAuth if Firebase is not available
    return GoogleAuthMethod.GoogleOAuth;
  }, [googleAuthEnabled]);
};
